import { render, staticRenderFns } from "./Saee12bRow.vue?vue&type=template&id=98c0273e"
import script from "./Saee12bRow.vue?vue&type=script&lang=js"
export * from "./Saee12bRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports